// 省市运费选择器的纯函数。只操作地址库ID，不以地区名称作为主键。
export function units(provinces) {
  return provinces.reduce(
    (all, p) =>
      all.concat(
        p.children.map(c => ({ ...c, provinceId: p.id, provinceName: p.name }))
      ),
    []
  );
}
export function expand(codes, provinces) {
  return codes.reduce((all, id) => {
    const province = provinces.find(p => p.id === id);
    return all.concat(province ? province.children.map(c => c.id) : [id]);
  }, []);
}
export function searchRegions(provinces, keyword) {
  const key = (keyword || "").trim();
  return provinces
    .map(p => ({
      ...p,
      visible: p.name.includes(key)
        ? p.children
        : p.children.filter(c => c.name.includes(key))
    }))
    .filter(p => p.visible.length);
}
export function compact(codes, provinces) {
  const chosen = new Set(codes);
  const tags = [];
  provinces.forEach(p => {
    const cities = p.children.filter(c => chosen.has(c.id));
    if (cities.length === p.children.length)
      tags.push({
        key: `p${p.id}`,
        ids: cities.map(c => c.id),
        label: `${p.name}（${
          cities.length === 1 && cities[0].id === p.id ? "全部" : "全省"
        }）`
      });
    else
      cities.forEach(c =>
        tags.push({
          key: `c${c.id}`,
          ids: [c.id],
          label: `${p.name} · ${c.name}`
        })
      );
  });
  const valid = new Set(units(provinces).map(c => c.id));
  codes
    .filter(id => !valid.has(id))
    .forEach(id =>
      tags.push({
        key: `invalid${id}`,
        ids: [id],
        label: `无效地区 ${id}（请删除）`
      })
    );
  return tags;
}
export function ownership(template, except) {
  const result = {};
  if (except !== "free")
    template.free.forEach(id => {
      result[id] = "包邮";
    });
  if (except !== "blocked")
    template.blocked.forEach(id => {
      result[id] = "不配送";
    });
  template.groups.forEach((g, i) => {
    if (except !== `g${i}`)
      g.regions.forEach(id => {
        result[id] = `收费分组 ${i + 1}`;
      });
  });
  return result;
}
export function feeCents(value) {
  const text = String(value == null ? "" : value);
  if (!/^\d+(\.\d{1,2})?$/.test(text)) return null;
  const [yuan, decimals = ""] = text.split(".");
  // 只进行整数分计算，拒绝超长输入，避免浮点或溢出。
  if (yuan.length > 6) return null;
  const cents = Number(yuan) * 100 + Number(decimals.padEnd(2, "0"));
  return cents > 0 && cents <= 99999999 ? cents : null;
}
export function validateTemplate(template, provinces) {
  const errors = [];
  const name = (template.name || "").trim();
  if (!name || Array.from(name).length > 30)
    errors.push("模板名称必填，去首尾空格后最多30字。");
  const all = [...template.free, ...template.blocked];
  template.groups.forEach((g, i) => {
    if (!g.regions.length)
      errors.push(`收费分组${i + 1}未选择地区，请选择地区或删除空分组。`);
    if (feeCents(g.fee) === null)
      errors.push(
        `收费分组${i + 1}运费须大于0、不超过999999.99元，最多两位小数。`
      );
    all.push(...g.regions);
  });
  const expanded = expand(all, provinces),
    valid = units(provinces);
  if (new Set(expanded).size !== expanded.length)
    errors.push("存在重复地区或整省与城市重叠，请调整归属。");
  const validSet = new Set(valid.map(c => c.id));
  if (expanded.some(id => !validSet.has(id)))
    errors.push("存在无效地区编码，请删除后重新选择。");
  const assigned = new Set(expanded),
    missing = valid.filter(c => !assigned.has(c.id));
  if (missing.length)
    errors.push(
      `还有${missing.length}个配送地区未分配，例如${missing
        .slice(0, 4)
        .map(c => `${c.provinceName}·${c.name}`)
        .join("、")}。`
    );
  return errors;
}
